import React, { useEffect } from "react";
import {
  ComposableMap,
  Geographies,
  Geography,
} from "react-simple-maps";
import type { FeatureCollection, Geometry } from "geojson";

type Props = {
  width: number;
  height: number;
  stroke?: string;
  fill?: string;
  borderFC: FeatureCollection<Geometry> | null;
  adm2FC: FeatureCollection<Geometry> | null;
  zoom?: number;  // Ignored for static map, using scale instead
  scale?: number; // D3 scale for projection
  onMapReady?: () => void;  // Callback when map is ready
};

const LebanonMapBaseStatic: React.FC<Props> = ({
  width,
  height,
  stroke = "#1976d2",
  fill = "rgba(25, 118, 210, 0.08)",
  borderFC,
  adm2FC,
  scale = 14000,
  onMapReady
}) => {
  
  // Notify parent that static map is ready immediately
  useEffect(() => {
    if (onMapReady) {
      // Use a small timeout to ensure DOM is ready
      const timeout = setTimeout(() => {
        onMapReady();
      }, 50);
      return () => clearTimeout(timeout);
    }
  }, [onMapReady]);

  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        zIndex: 0,
        width: width,
        height: height,
      }}
    >
      <ComposableMap
        projection="geoMercator"
        projectionConfig={{ 
          scale, 
          center: [35.9, 33.9] 
        }}
        width={width}
        height={height}
        style={{
          width: '100%',
          height: '100%',
        }}
      >
        {/* Country border - main outline */}
        {borderFC && borderFC.features && (
          <Geographies geography={borderFC}>
            {({ geographies }) =>
              geographies.map((geo) => (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  fill="#EEE"
                  stroke={stroke}
                  strokeWidth={2.5}
                  style={{
                    default: { outline: 'none' },
                    hover: { outline: 'none' },
                    pressed: { outline: 'none' },
                  }}
                />
              ))
            }
          </Geographies>
        )}

        {/* Administrative divisions overlay (only if provided via showDistricts) */}
        {adm2FC && adm2FC.features && (
          <Geographies geography={adm2FC}>
            {({ geographies }) =>
              geographies.map((geo) => (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  fill={fill}
                  stroke={stroke}
                  strokeWidth={1.5}
                  strokeOpacity={0.6}
                  fillOpacity={0.1}
                  style={{
                    default: { outline: 'none' },
                    hover: { outline: 'none' },
                    pressed: { outline: 'none' },
                  }}
                />
              ))
            }
          </Geographies>
        )}
      </ComposableMap>
    </div>
  );
};

LebanonMapBaseStatic.displayName = 'LebanonMapBaseStatic';

export default LebanonMapBaseStatic;

